import React, {Component} from "react";
import {graphql} from "react-apollo";
import {fromJS, List} from "immutable";
import Table from "../../../components/Table";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import PaginatorButton from "../../../components/PaginatorButton";
import PurchaseOrderItem from "./PurchaseOrderItem";
import {LIST_PURCHASE_ORDERS, ON_PURCHASE_ORDER_UPDATED} from "../../../queries/purchaseOrders";

const tableHeader = List(["PO Number", "Supplier", "Deliver To", "Ordered", "Expected", "Qty", "Status"]);

class PurchaseOrdersList extends Component {

  componentDidMount() {
    const {data} = this.props;
    this.unsubscribe = data.subscribeToMore({
      document: ON_PURCHASE_ORDER_UPDATED,
      updateQuery: (prev) => {
        data.refetch();
        return prev;
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  render() {
    const {loading, error, purchaseOrders} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    const orders = fromJS(purchaseOrders);
    return (
      <div>
        <Table
          data={orders.get("entries")}
          renderer={PurchaseOrderItem}
          onItemClick={(itemData) => this.props.onSelectionChange(itemData.get("id"))}
          tableHeader={tableHeader}
          extraClassName="PurchaseOrdersList"
          itemKey="id"
          mode="table"
          showCount={true}
          />
        <PaginatorButton metadata={orders.get("metadata")} onNext={this.handleNext.bind(this)} />
      </div>
    )
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {pagination: {after: afterId}},
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          purchaseOrders: {
            __typename: prev.purchaseOrders.__typename,
            metadata: fetchMoreResult.purchaseOrders.metadata,
            entries: [...prev.purchaseOrders.entries, ...fetchMoreResult.purchaseOrders.entries]
          }
        }
      }
    })
  }
}

export default graphql(LIST_PURCHASE_ORDERS, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {filter: {status: props.statusFilter, destinationWarehouseId: props.destinationFilter}}
  })
})(PurchaseOrdersList);
